import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DuiNotificationsService } from '../../shared/services/dui-notifications.service';
import { FormUtilsService } from '../../shared/services/form-utils.service';
import { buildLoginRedirectUrl } from '../utils/url-utils';

@Injectable({
    providedIn: 'root'
})
export class ErrorHandlerService {
    private router = inject(Router);
    private translate = inject(TranslateService);
    private notifications = inject(DuiNotificationsService);
    private formUtils = inject(FormUtilsService);

    handle(error: any, skipAuthErrorHandler?: boolean, skipToastErrorHandler?: boolean, fallbackErrorMsgKey?: string) {
        // Manage error status codes
        switch (error.status) {
            case 401: // Unauthorized: Invalid authentication credentials | session expiration
                localStorage.removeItem('accessToken');
                this.formUtils.finishSubmitAction();

                if (!skipAuthErrorHandler) {
                    console.log('Error 401, redirige al login', this.router);

                    const companyCodeFromStorage = localStorage.getItem('lastUserLoginBrand');
                    const loginUrl = buildLoginRedirectUrl(this.router.url, companyCodeFromStorage);
                    this.router.navigateByUrl(loginUrl);
                }

                break;
            case 403: // Forbidden: server denied response
                this.notifications.showErrorNotification(this.translate.instant('403.notification'));
                break;

            case 404: // Url not found
                // router.navigate(['/not-found']);
                this.router.navigate(['/not-found']);
                break;

            case 422: // Unprocessable content
                if (!skipToastErrorHandler) {
                    const message = error.error?.localizedError || (fallbackErrorMsgKey ? this.translate.instant(fallbackErrorMsgKey) : '');
                    this.notifications.showErrorNotification(message);
                }
                this.formUtils.finishSubmitAction();
                break;

            case 500: // Internal server error
                // TO DO: Save the current request to implement retries
                this.router.navigate(['/server-error']);
                break;
        }
    }
}
